import React, { Component } from 'react';
import { FormGroup, ControlLabel} from 'react-bootstrap';
import StepIndicator from '../../../shared/StepIndicator';
import paths from '../../../config/path';
import { setItemToSession, getContentByLocal, isArray, ToDBC, ToCDB } from '../../../utils';
import './styles/styles.css';
import { replaceSection,fix,aoformQuestionShouldDisplay as questionShouldDisplay } from '../../../utils/AOFormUtils';
import AOForm from '../../../shared/AOForm';
import history from '../../../utils/history';
import {
    numberOnly,
    decimal,
    character,
    characterNnumber,
    email
} from '../../../utils/ValidationUtils';

/* eslint-disable array-callback-return */
//const BasicInfo = (props) = > {}
class BasicInfo extends Component {
  constructor(props) {
        super(props);
        this.state = {
            isShowError: false,
            show:false,
            applicationInfoClone:this.props.applicationInfo?JSON.parse(JSON.stringify(this.props.applicationInfo)):null
        }
  }

  onChangeNextSubmit = () => {
        const { saveQuestionsForm, businessInfo, validatePQForm, applicationInfo, section, saveAppInfo} = this.props;
        validatePQForm().then(()=>{
            let data = this.buildSubmitDataContainer();
            businessInfo.answerDetails = {
                ...businessInfo.answerDetails,
                ...data
            };
            //william jiang:
            const nature_of_business = data.busiNature.map(bn => bn.natureBusi);
            const tagInfo = { 
                form_field_4: nature_of_business, 
                form_field_5: data.accountLocation  
            };
            window.info1Tag = tagInfo;  //taggingHandler(tagInfo);
            return saveQuestionsForm({
                "answerDetails": data,
                "qianHaiInfo": {...businessInfo.qianHaiInfo}
            });
        }).then((resp)=>{
            const newapplicationInfo = replaceSection(applicationInfo, section)
            saveAppInfo(newapplicationInfo);
            this.props.updateStep({"progressIndex": 2, "status": 1});
            history.push(paths.accountQuestion.path);
        }).catch(error => {
            this.setState({
                isShowError: true
            });
            window.scrollTo(0, 0)
        })
  }

  buildSubmitDataContainer = () => {
      const {section} = this.props;
      let data = {}
      section.questions.map((question,index)=>{
            this.buildSubmitDataActorNew(question,data)
      })
      data.repeatAccount = this.buildAccountTypeBusinessData()
      data.busiNature = this.buildIndustryLevelBusinessData()
      data.majorBusiCountry = this.buildCountryBusinessData()
      return data
  }

   buildSubmitDataActorNew = (question,data) => {
     if(question.questionIndicator !== "repeatAccountGroup" && question.questionIndicator !== "busiNatureGroup"){
        question.subQuestions.map((subq,index)=>{
            if(subq.subQuestions){
                this.buildSubmitDataActorNew(subq,data)        
            }else if(subq.userAnswer){
                switch (subq.answerType) {
                    case 5: // DropdownList
                        data[subq.questionIndicator] = this.findIndicatorByAnswerId(subq, subq.userAnswer.chosenAnswerId)
                        break;
                    case 27:
                        //handled by this.buildCountryBusinessData
                        break;
                    case 4: // Input
                        data[subq.questionIndicator] = subq.userAnswer.contents[0]
                        break;
                    case 9: // Email
                        data[subq.questionIndicator] = subq.userAnswer.contents[0]
                        break;
                    case 11: // CascadingDroupDownList
                        //handled by this.buildIndustryLevelBusinessData
                        break;
                    default:
                        break;
                }
                if(subq.questionIndicator === "companyNameE" && subq.userAnswer.contents && subq.userAnswer.contents[0] && subq.userAnswer.contents[0] !== ""){
                    subq.userAnswer.contents[0] = ToCDB(subq.userAnswer.contents[0]); //转半角
                    data[subq.questionIndicator] = ToCDB(subq.userAnswer.contents[0]); //转半角
                } else if(subq.questionIndicator === "companyNameC" && subq.userAnswer.contents && subq.userAnswer.contents[0] && subq.userAnswer.contents[0] !== ""){
                    subq.userAnswer.contents[0] = ToDBC(subq.userAnswer.contents[0]); //转全角
                    data[subq.questionIndicator] = ToDBC(subq.userAnswer.contents[0]); //转全角
                }
               
            }
        })
     }

  }

  buildAccountTypeBusinessData = () => {
        const {section,applicationInfo} = this.props;
        const app = JSON.parse(JSON.stringify(applicationInfo))
        app.sections[0] = section
        const targetQuestion = section.questions[3].subQuestions[0]
        let result = []
        targetQuestion.subQuestions.map((subq,index)=>{
            let temp = {}
            subq.subQuestions.map((q,i)=>{
                const shouldDisplay = questionShouldDisplay(app, q);
                if(shouldDisplay){
                    switch (q.answerType) {
                        case 5:
                            temp[q.questionIndicator] = this.findIndicatorByAnswerId(q, q.userAnswer.chosenAnswerId);
                            break;
                        case 4:
                            temp[q.questionIndicator] = q.userAnswer.contents[0];
                            break;
                        default:
                            break;
                    } 
                } else {
                    q.userAnswer = null
                }               
            })           
            result.push(temp)
        })
        return result
  }

 buildIndustryLevelBusinessData = () => {
        const {section,applicationInfo} = this.props;
        const app = JSON.parse(JSON.stringify(applicationInfo))
        const targetQuestion = section.questions[2]
        let result = []
        targetQuestion.subQuestions.map((subq,index)=>{
            let temp = {}
            subq.subQuestions.map((q,i)=>{
                const shouldDisplay = questionShouldDisplay(app, q);
                if(shouldDisplay && q.hide === false){
                    if(q.questionIndicator === "perOfIndustry"){
                        temp[q.questionIndicator] = q.userAnswer.contents[0]
                    }else{
                        let userAnswer = q.userAnswer.chosenAnswerId
                        const index = userAnswer.split(":")[1]*1-1                    
                        temp[q.questionIndicator] = q.answers[index].indicator
                    }                  
                }                
            })           
            result.push(temp)
        })
        return result
  }

   buildCountryBusinessData = () => {
        const {section,countryListDatas} = this.props;
        const targetQuestion = section.questions[1].subQuestions[0]
        let userAnswer = targetQuestion.userAnswer.chosenAnswerId
        const index = userAnswer.split(":")[1]*1-1               
        return countryListDatas[index].indicator
  }

  findIndicatorByAnswerId = (question,answerId) => {
        let indicator = ""
        if(question && question.answers){
            let answer = question.answers.filter((answer,index)=>{
                return answer.answerId === answerId
            })
            if(answer && isArray(answer) && answer.length > 0){
                indicator = answer[0].answerIndicator
            }          
        }
        return indicator    
  }

  showBusinessPopup = (isShown) => {
       this.setState({
           show : isShown
       });
  };
  setupBusinessInfo = () => {
      history.push(paths.businessInformation.path);
  };

  getInputContent = (userAnswer) => {
        return userAnswer && userAnswer.contents && userAnswer.contents.length > 0 && userAnswer.contents[0];
  }

  checkComponentIsDisplay = (item) => {
     const { applicationInfo, section } = this.props
     let { applicationInfoClone } = this.state
     if(!applicationInfoClone){
         applicationInfoClone = JSON.parse(JSON.stringify(applicationInfo))
     }
     applicationInfoClone.sections[0] = section
     return questionShouldDisplay(applicationInfoClone,item);
  }

  handleAccountTypeGroup = (obj, index) => {
        const { subQuestions, questionLocales, condition, questionId} = obj;
        const { selectedLanguage, i18n, accountTypeDelAction, accountTypeAddAction } = this.props;
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        const questions = obj.subQuestions.map((item,i) => {
                return item.subQuestions.map((q,num) => {
                    const shouldDisplay = this.checkComponentIsDisplay(q);
                    if(!shouldDisplay)
                        return false
                    return this.handleQuestion(q,num)
                })
        })
        const repeatMax = condition && JSON.parse(condition).repeatMax
        return (
            <AOForm.CombinedGroup
                key = {questionId}
                itemArray={subQuestions}
                onDelAction={accountTypeDelAction}
                onAddAction={accountTypeAddAction}
                addBtnText={{ text: i18n.addAccountType, dataKey: 'addValue' }}
                removeBtnText={{ text: i18n.delete, dataKey: 'removeItem' }}
                titleContent={{ title: questionTitle, dataKey: 'CombinedGroup' }}
                questionRel={obj}
                repeatMax={repeatMax ? repeatMax : 5}
            >
                {questions}
            </AOForm.CombinedGroup>
        )
  };

  handleSelectGroupAddDeleteDispatcher = (obj,i) => {
        if(obj && obj.questionId === "Q001-004-001"){
            return (
                <div className = "basicInfo-form-group">
                    {
                       this.handleAccountTypeGroup(obj,i)                
                    }
                </div>
            )
        }
  }

  handleIndustryLevelGroup = (obj,index) => {
        const { subQuestions, condition, questionId} = obj;
        const { i18n, industryLevelAddAction, industryLevelDelAction } = this.props;
        const questions = obj.subQuestions.map((item,i) => {
                return item.subQuestions.map((q,num) => {
                    const shouldDisplay = this.checkComponentIsDisplay(q);
                    if(!shouldDisplay)
                        return false
                    return this.handleQuestion(q,num)
                })
        })
        const repeatMax = condition && JSON.parse(condition).repeatMax
        return (
            <AOForm.CombinedGroup
                key = {questionId}
                itemArray={subQuestions}
                onDelAction={industryLevelDelAction}
                onAddAction={industryLevelAddAction}
                addBtnText={{ text: i18n.addIndustryLevel, dataKey: 'addValue' }}
                removeBtnText={{ text: i18n.delete, dataKey: 'removeItem' }}
                titleContent={{ title: "", dataKey: 'CombinedGroup' }}
                questionRel={obj}
                repeatMax={repeatMax ? repeatMax : 3}
            >
                {questions}
            </AOForm.CombinedGroup>
        )
  }

  handleQuestion = (question,i) => {
        const { selectedLanguage, valueDidChange,onBlurAction, errorList, errorMsgs, countryListDatas, section } = this.props;
        const { 
            questionLocales,
            answerType,
            answers,
            userAnswer,
            hintLocales,
            questionId,
            questionIndicator,
            hintStyle
        } = question;
        const { i18n } = this.props;
        const errorMsg = errorMsgs[questionId];
        const questionTitle = getContentByLocal(questionLocales, selectedLanguage);
        const questionMarkDetail = hintLocales && getContentByLocal(hintLocales, selectedLanguage);
        const isError = errorList.indexOf(questionId) !== -1;
        let defaultValue = null;
        switch (answerType) {
            case 1: 
                const radioItems = answers && answers.map( answer => {
                    return {
                        'dataIndex': answer.index,
                        'value': answer.answerId,
                        'display': getContentByLocal(answer.answerLocales, selectedLanguage)
                    }
                });
                if (userAnswer) {
                    defaultValue = userAnswer.chosenAnswerId
                }
                let radioArrays = {
                    question:{
                        title: questionTitle,
                        dataKey: questionIndicator
                    },
                    questionTip: '',
                    radioName: questionIndicator,
                    defaultValue: defaultValue,
                    radioItems:radioItems,
                    questionRel: question
                };
                if (questionMarkDetail) {
                    radioArrays = {
                        ...radioArrays,
                        questionMark: {
                            hints: questionMarkDetail
                        }
                    }
                }
                return <AOForm.RadioButton
                    handleRadioChange={ valueDidChange }
                    content={radioArrays}
                />;
            case 4: // Input Field
                    
                    // 实体类别 display其他input field
                    const shouldDisplay = this.checkComponentIsDisplay(question);
                    if(question && question.questionIndicator === "OtherEntityTypeValue") {
                        if(!shouldDisplay) {
                            return false
                        } 
                    }

                    const { inputPreLabelLocales, inputSfxLabelLocales, condition } = question;
                    const conditionObj = condition && JSON.parse(condition)
                    const prefix = inputPreLabelLocales && getContentByLocal(inputPreLabelLocales, selectedLanguage)
                    const suffix = inputSfxLabelLocales && getContentByLocal(inputSfxLabelLocales, selectedLanguage)
                    if (userAnswer) {
                        defaultValue = this.getInputContent(userAnswer)
                    }
                    let inputContent = {
                        textValue: defaultValue,
                        subtitle: {
                            title: questionTitle,
                            dataKey: questionIndicator+"_title",
                        },
                        isError: isError,
                        errorMessage: errorMsg,
                        isDisabled: false,
                        questionRel: question,
                        dataKey: questionIndicator,
                        dataLabel:questionIndicator
                    };
                    if (questionMarkDetail) {
                        if(questionId === "Q001-002-004" && hintStyle){
                            //Current data structure not meet this requiremet , so this is tmp solution for UT test , will be fixed later
                            const tips = hintStyle && getContentByLocal(JSON.parse(hintStyle), selectedLanguage);
                            inputContent = {
                                ...inputContent,
                                questionMark: {
                                    hints: questionMarkDetail,
                                    dataKey:questionIndicator+"_hints"
                                },
                                questionTip: {
                                    title: tips,
                                    dataKey:questionIndicator+"_tips"
                                }
                            }
                        }else{
                            if(hintStyle){
                                inputContent = {
                                    ...inputContent,
                                    questionTip: {
                                        dataKey: `${questionIndicator}-description`,
                                        title: questionMarkDetail
                                    }
                                }
                            }else{
                                inputContent = {
                                    ...inputContent,
                                    questionMark: {
                                        hints: questionMarkDetail
                                    }
                                }
                            } 
                        }                     
                    }

                    let otherParams = {}
                    if (conditionObj) {
                        const { inputType, maxLength } = conditionObj;
                        if (typeof (inputType) !== "undefined") {
                            switch (inputType) {
                                case 0: { // numberOnly
                                    otherParams = {
                                        ...otherParams,
                                        formatAction: numberOnly,
                                        isNumber: true
                                    }
                                    break;
                                }
                                case 1: { // decimal
                                    otherParams = {
                                        ...otherParams,
                                        formatAction: decimal,
                                        isNumber: true
                                    }
                                    break;
                                }
                                case 2: { // character
                                    otherParams = {
                                        ...otherParams,
                                        formatAction: character
                                    }
                                    break;
                                }
                                case 3: { // characterNnumber
                                    otherParams = {
                                        ...otherParams,
                                        formatAction: characterNnumber
                                    }
                                    break;
                                }
                                case 4: { // email
                                    otherParams = {
                                        ...otherParams,
                                        formatAction: email
                                    }
                                    break;
                                }
                                default:
                                    break;
                            }
                        }
                        if (typeof (maxLength) !== "undefined") {
                            otherParams = {
                                ...otherParams,
                                maxLength
                            }
                        }
                    }

                    return <AOForm.InputWithPrefixSuffix
                        key ={questionIndicator}
                        onChangeAction={ valueDidChange }
                        onBlurAction={ onBlurAction }
                        content={ inputContent }
                        disabled={ false }
                        prefix={ prefix }
                        suffix={ suffix }
                        {...otherParams}
                    />;
            case 5: // Drop down list
            case 27:
                let answerOptions = null
                if(answerType === 5){
                    answerOptions = answers && answers.map(item => {
                        const isShow = this.basicQuestionShouldDisplay(section, item);
                        if(!item.hide && !isShow){
                            return {
                                id: item.answerId,
                                text: getContentByLocal(item.answerLocales, selectedLanguage),
                                dataKey: item.answerId
                            }
                        }
                    });

                    answerOptions = answerOptions.filter((item) =>{
                        return item
                    })
                }else if(answerType === 27){
                    const baseAnswerId = questionId.replace('Q', 'A') + ":";                     
                    answerOptions = countryListDatas && countryListDatas.map( (item, index) => {
                        const answerId = baseAnswerId + fix(index + 1)
                        return {
                            id: answerId,
                            text: getContentByLocal(item.leveLocales, selectedLanguage),
                            dataKey: `${questionIndicator}_${item.indicator}`
                        }
                    });
                    
                }
                
                if(answerOptions.length === 0){
                    return false
                }

                if (answerOptions) {
                    answerOptions = [{ id: "", 'text': i18n.selectPlaceholder }, ...answerOptions];
                }
                if (userAnswer) {
                    if (answerType === 5) {
                        defaultValue = this.getEntityAnswer(answerOptions, userAnswer);
                    } else if (answerType === 27) {
                        defaultValue = userAnswer.chosenAnswerId;
                    }
                }
                let selectContent = {
                    itemTitle: {
                        text: questionTitle,
                        dataKey: questionIndicator +"_title"
                    },
                    validatedTips: isError ? errorMsg : '',
                    selectOptions: answerOptions,
                    defaultValue: defaultValue,
                    questionRel: question,
                    isError: isError,
                    dataKey: questionIndicator
                };

                if (questionMarkDetail) {
                    if(questionId === "Q001-002-004" && hintStyle){
                        //Current data structure not meet this requiremet , so this is tmp solution for UT test , will be fixed later
                        const tips = hintStyle && getContentByLocal(JSON.parse(hintStyle), selectedLanguage);
                        selectContent = {
                            ...selectContent,
                            questionMark: {
                                hints: questionMarkDetail,
                                dataKey:questionIndicator+"_hints"
                            },
                            questionTip: {
                                title: tips,
                                dataKey:questionIndicator+"_tips"
                            }
                        }
                    }else{
                        selectContent = {
                            ...selectContent,
                            questionMark: {
                                hints: questionMarkDetail,
                                dataKey:questionIndicator+"_hints"
                            }
                        }
                    }
                }

                return <AOForm.Select
                    content={selectContent}
                    validationState={false}
                    disabled={false}
                    key = {questionIndicator}
                    onChangeAction={ (question, newValue, event) => { valueDidChange(question, newValue) }}
                    
                />;
            case 9: // Email Field
                    if (userAnswer) {
                        defaultValue = this.getInputContent(userAnswer)
                    }
                    let emailContent = {
                        textValue: defaultValue,
                        subtitle: {
                            title: questionTitle,
                            dataKey: questionIndicator+"_title"
                        },
                        isError: isError,
                        errorMessage: errorMsg,
                        isDisabled: false,
                        questionRel: question,
                        dataLabel:questionIndicator,
                        dataKey: questionIndicator
                    };
                    if (questionMarkDetail) {
                        emailContent = {
                            ...emailContent,
                            questionMark: {
                                hints: questionMarkDetail
                            }
                        }
                    }
                    let emailParams = {formatAction: email}
                    return <AOForm.InputWithPrefixSuffix
                        onChangeAction={ valueDidChange }
                        onBlurAction={onBlurAction }
                        content={ emailContent }
                        disabled={ false }
                        prefix=""
                        suffix=""
                        {...emailParams}
                    />;
            case 11: // cascadingDropDownListComponents
                if(question.hide){
                    return false
                }
                // let answerOptionsCascading = answers && answers.map(item => {
                //          if(!item.hide){
                //             return {
                //                 id: item.answerId,
                //                 text: getContentByLocal(item.answerLocales, selectedLanguage),
                //                 dataKey: item.answerId
                //             }  
                //          }                                    
                // });

                const baseAnswerId = questionId.replace('Q', 'A') + ":";                     
                let answerOptionsCascading = answers && answers.map( (item, index) => {
                    if(!item.hide){
                        const answerId = baseAnswerId + fix(index + 1)
                        return {
                            id: answerId,
                            text: getContentByLocal(item.leveLocales, selectedLanguage),
                            dataKey: `${questionIndicator}_${item.indicator}`
                        }
                    }                
                });
                answerOptionsCascading = answerOptionsCascading.filter((item) =>{
                    return item
                })
                if(answerOptionsCascading.length === 0){
                    return false
                }

                if (answerOptionsCascading) {
                    answerOptionsCascading = [{ id: "", 'text': i18n.selectPlaceholder }, ...answerOptionsCascading];
                }
                if (userAnswer) {
                    defaultValue = userAnswer.chosenAnswerId
                }

                let selectContentCascading = {
                    itemTitle: {
                        text: questionTitle,
                        dataKey: questionIndicator +"_title"
                    },
                    validatedTips: isError ? errorMsg : '',
                    selectOptions: answerOptionsCascading,
                    defaultValue: defaultValue,
                    questionRel: question,
                    isError: isError,
                    dataKey: questionIndicator
                }

                if (questionMarkDetail) {
                    selectContentCascading = {
                        ...selectContentCascading,
                        questionMark: {
                            hints: questionMarkDetail,
                            dataKey:questionIndicator+"_hints"
                        }
                    }
                }

                return <AOForm.Select
                    content={selectContentCascading}
                    validationState={false}
                    disabled={false}
                    key = {questionIndicator}
                    onChangeAction={ (question, newValue, event) => { valueDidChange(question, newValue) }}
                    
                />;
            case 17: // SelectGroup
                return this.handleSelectGroupAddDeleteDispatcher(question,i);
            case 0: // zeroHandler
                break;
            default:
                return null;
        }
    }
    getEntityAnswer = (answerOptions, userAnswer) => {
        let result = false;
        let defaultValue = null;
        const userAnswerTmp = userAnswer.chosenAnswerId;
        answerOptions.forEach(item => {
            if (item.id === userAnswerTmp) {
                result = true;
            }
        });
        if (result) defaultValue = userAnswerTmp;
        return defaultValue;
    }

    basicQuestionShouldDisplay = (section, answer) => {
        const userAnswer = section.questions[1].subQuestions[1] && section.questions[1].subQuestions[1].userAnswer && section.questions[1].subQuestions[1].userAnswer
        const majorBusiCountryAnser = userAnswer && userAnswer.chosenAnswerId;
        let result = false;
        if (answer && majorBusiCountryAnser === 'A001-002-002:002' && answer.answerIndicator === 'FCYSAccount') {
            result = true;
        }
        return result;
    }

  backAction = () => {
      setItemToSession({isLogin : true});
      history.push(paths.companyRegistration.path);
  }

  render() {
    const { i18n, appMessages, selectedLanguage, section } = this.props
    const { isShowError } = this.state
    return (
            <div className="dynamic-form basicInfo-container" data-id="BasicInfo">
                <div className="container basicInfo-box">
                    <StepIndicator currentStep={3} totalStep={5} stepInfo={appMessages.stepInfo} stepTitle={i18n.stepTitle} />
                    
                    <div className="basicInfo-top">
                        <AOForm.FormTitle content={{
                            title: {
                                text: i18n.title,
                                dataKey: 'basicInfo-information-title'
                            },
                            subTitle: {
                                text: i18n.tip,
                                dataKey: 'basicInfo-information-title'
                            },
                            optional_msg: { text: appMessages.form_base_content.optional_msg, dataKey: "optional_msg"},
                        }}
                        errorAtTop = {{
                            content: appMessages.form_base_content.form_error_prompt,
                            isDisplay: isShowError
                        }}
                        />
                    </div>
                    
                    <div className="basicInfo-list">
                         {
                            section && section.questions && section.questions.map((item, index) => {
                                const title = getContentByLocal(item.questionLocales, selectedLanguage)
                                const tip = getContentByLocal(item.hintLocales, selectedLanguage)
                                if(item.questionId === "Q001-003"){
                                    return (
                                        <FormGroup key={`basicInfo-${index}`}>
                                            <ControlLabel>
                                                <div className="title" data-key="title">
                                                    {title}
                                                </div>
                                            </ControlLabel>
                                            <p className="font-body3 item-question-tip" data-key="Q001-003s-description">{tip}</p>
                                            <div className="clearfix basicInfo-form" key={index}>
                                            {
                                              this.handleIndustryLevelGroup(item,index)                           
                                            }
                                            </div>                                 
                                        </FormGroup>
                                    )
                                }else{
                                    return (
                                        <FormGroup key={`basicInfo-${index}`}>
                                            <ControlLabel>
                                                <p className="title" data-key="title"><span>{title}</span></p>
                                            </ControlLabel>
                                            {
                                                item.subQuestions.map((subItem,i)=>{                                                   
                                                    return (
                                                        <div className="clearfix basicInfo-form" key={i}>
                                                            {this.handleQuestion(subItem,i)}                                                       
                                                        </div>
                                                    )                                             
                                                })                                 
                                            }                                      
                                        </FormGroup>
                                    )
                                }
                                
                            })
                        }
                        <AOForm.BottomButtonsGroup
                            disabled={false}
                            saveButtonShow = {false}
                            content={i18n.bottomButtonsContent}
                            backAction={this.backAction}
                            completeFormAction={this.onChangeNextSubmit}
                        />
                    </div>
                </div>
            </div>
    );
  }
}

export default BasicInfo;



// WEBPACK FOOTER //
// ./src/views/BasicInfo/components/BasicInfo.js